/**
 * SAP CONFIDENTIAL
 *
 * This software is confidential proprietary software licensed by SAP SE
 * and is not to be used, duplicated or disclosed to anyone without the
 * prior written permission of SAP.
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

@Injectable()
export class GdprConfigurationService {
  private gdprMetaDataUrl: string = environment.host + '/getGDPRMetaData/';
  private saveGdprMetaData: string = environment.host + '/saveOrUpdateGDPRMetaData/';
  private gdprCustomerEventsData: string = environment.host + '/getGDPRCustomerEventsData/';
  private gdprParticipantRanksJoinDatesDataUrl: string = environment.host + '/getParticipantRanksJoinDates/';
  private gdprDeleteParticipant : string = environment.host + '/deleteGDPRTitltRankConfigurations/';
  private gdprDeleteCustomer : string = environment.host + '/deleteGDPRCustomerCriterias/';
  
  constructor(private http: HttpClient) { }

  public getGDPRMetaData(regionCode: string) {
    return this.http.get(this.gdprMetaDataUrl + regionCode).toPromise();
  }

  public saveOrUpdateGDPRMetaData(gdprConfigObj: any, regionCode: string) {
		return this.http.post(this.saveGdprMetaData + regionCode, gdprConfigObj).toPromise();
	}

  public getGDPRCustomerEventsData(regionCode: string) {
    if (regionCode) {
      return this.http.get(this.gdprCustomerEventsData + regionCode).toPromise();
    } else {
      return this.http.get(this.gdprCustomerEventsData).toPromise();
    }
  }

  public getGDPRParticipantRanksJoinDatesData() {
    return this.http.get(this.gdprParticipantRanksJoinDatesDataUrl).toPromise();
  }

  public deleteParticipantData(participantId: any) {
    return this.http.delete((this.gdprDeleteParticipant + participantId).toString()).toPromise();
  }

  public deleteCustomerData(customerId: any){
    return this.http.delete((this.gdprDeleteCustomer + customerId).toString()).toPromise();
  }
}
